"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgToilet = function SvgToilet(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 2)",
    stroke: "#4A4A4A",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.71 11.473c.949-1.217 1.535-2.89 1.535-4.738C12.245 3.015 9.869 0 6.939 0S1.633 3.015 1.633 6.735c0 1.846.585 3.52 1.534 4.736"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.939,
    cy: 6.735,
    rx: 3.265,
    ry: 4.286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 13,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.527 13.5A4.5 4.5 0 0 0 6 17.5h2a4.5 4.5 0 0 0 4.473-4H1.527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.358 18.145-4.664-.064A2.986 2.986 0 0 0 4.17 19h5.66a2.984 2.984 0 0 0-.472-.855z",
    strokeWidth: 2
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgToilet);
var _default = exports["default"] = Memo;